export const GET_PRESET_REGIMENS = 'getPresetRegimens';
export const GET_NEW_PRESET_REGIMENS = 'getNewPresetRegimens';
export const GET_REGIMEN = 'getRegimen';